/**
 * Web mock for `react-native-webrtc`.
 *
 * The native module's built ESM imports `react-native/Libraries/vendor/emitter/
 * EventEmitter`, an internal path that does not exist on `react-native-web`, so
 * webpack cannot resolve the real package for the browser/Cloudflare Pages build
 * and the export fails to compile. The softphone layer (app/helpers/CallProvider.js)
 * only pulls it in through a try/catch-guarded lazy `require` to register the
 * WebRTC globals jssip relies on — but webpack still statically bundles that
 * require regardless of the runtime guard.
 *
 * On web the browser already ships native WebRTC (`RTCPeerConnection` etc.), which
 * jssip uses directly, so the react-native-webrtc polyfill is never needed. This
 * stub keeps the build resolvable and makes `registerGlobals()` a safe no-op; the
 * globals below simply forward to the browser's built-ins when present.
 */

const g = typeof globalThis !== 'undefined' ? globalThis : {};

/** No-op on web — the browser already exposes the WebRTC globals natively. */
function registerGlobals() {}

module.exports = {
  registerGlobals,
  RTCPeerConnection: g.RTCPeerConnection,
  RTCIceCandidate: g.RTCIceCandidate,
  RTCSessionDescription: g.RTCSessionDescription,
  RTCView: () => null,
  MediaStream: g.MediaStream,
  MediaStreamTrack: g.MediaStreamTrack,
  mediaDevices: g.navigator ? g.navigator.mediaDevices : undefined,
  permissions: undefined,
};
